import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_HEADERS, ENDPOINTS } from "../../constants/api";
import { baseQueryWithAuthCheck } from "./helper";
import { FETCH_FOLDER, FOLDER_COUNT, USER_PROFILES } from "./tags";
import { FetchProfilesResponse, FolderManagementHeaderRes, MasterDataResponse, TransformedUserProfileData, TransformedUserProfileResponse } from "@/types/api-response";
import { FetchProfilesPayload, FolderOptionType, GetFMHeaderPaylod, GetMasterDataRavenPayload, RTKArgs, TemplateType, UserInfoPayload, GetSavedDataPayload, ProfilesContactedPayload, ProfilesContactedRes, LinkedSearchRes, GetConnectionsPayload, GetShareFolderRecDetailsPaylod, GetMasterDataPayload, TrailPayload, TrailResponse  } from "@/types/api-payload";
import { callFromMiddleware, convertFilterStateFilterPayload, extractDomain } from "@/utils/index";
import { getUserDetails } from "@/utils/getUserDetails";
import { currentCompanyExperience, formatCurrentExp, formatDate, getEducationString, getExperienceString, getNoticeText,  getStateNameFromMapping, mergeEmployerIndustryCategory, returnFallbackIfEmpty, formatActivityDate } from "@/utils/userProfileCard";
import { IInitialFilterState } from "@/pages/FolderManagement/context/FilterContext";
import { ManageFolderAPIRecShareRes } from "@/types/index";
import { getRequiredCtcDetails } from "@/pages/FolderManagement/ProfileCardRightBody";

const baseQuery = fetchBaseQuery({
  baseUrl: window.location.origin,
  headers: API_HEADERS,
  credentials: "include",
});
const local = window.location.hostname.includes("localhost") ? true : false;
const userDetails = getUserDetails();

export const folderManagementApi: any = createApi({
  reducerPath: "foldermanagement",
  baseQuery: baseQueryWithAuthCheck(baseQuery),
  tagTypes: [USER_PROFILES, FOLDER_COUNT, FETCH_FOLDER],
  endpoints: (builder) => ({
    getRawUserProfile: builder.query<any, RTKArgs<IInitialFilterState>>({
      query: (args) => {
        const userInfo: UserInfoPayload = {
          channel_id: args.channelId,
          corp_id: args.corpId,
          sub_channel_id: args.subhchannelId,
          subuid: args.recruiterId,
          site_context: args.siteContext,
        };
    
        const body: FetchProfilesPayload = {
          ...userInfo,
          ...convertFilterStateFilterPayload(args.body!),
        };
    
        return {
          url: callFromMiddleware(ENDPOINTS.getUserProfiles),
          body,
          params: args.params,
          method: "POST",
        };
      },
      providesTags: [USER_PROFILES], // No transformResponse, returns raw data as is
    }),
    
    getUserProfile: builder.query<
      TransformedUserProfileResponse,
      RTKArgs<IInitialFilterState>
    >({
      query: (args) => {
        const userInfo: UserInfoPayload = {
          // channel_id: Number(userDetails?.channel_id) || 1,
          // corp_id: Number(userDetails?.corp_id),
          // sub_channel_id: Number(userDetails?.subhchannel_id) || 1,
          // subuid: Number(userDetails?.recruiter_id),
          // site_context: userDetails?.site_context ?? "rexmonster",
          channel_id: args.channelId,
          corp_id: args.corpId,
          sub_channel_id: args.subhchannelId,
          subuid: args.recruiterId,
          site_context: args.siteContext,
        };
        // console.log("qweqweqwe",args.body)
        const body: FetchProfilesPayload = {
          ...userInfo,
          ...convertFilterStateFilterPayload(args.body!),
        };

        return {
          url: callFromMiddleware(ENDPOINTS.getUserProfiles),
          body,
          params: args.params,
          method: "POST",
        };
      },
      providesTags: [USER_PROFILES],
      transformResponse(
        baseQueryReturnValue: FetchProfilesResponse,
        meta,
        arg
      ) {
        const allResumes = baseQueryReturnValue.all_resume;
        console.log("baseQueryReturnValue.all_resume",baseQueryReturnValue.all_resume)
        const data: TransformedUserProfileData[] = allResumes.map(
          (resume: any) => {
            const dataItems: TransformedUserProfileData = {
              source: resume?.profile_type,
              application_type:resume?.application_type,
              name: resume?.name ? resume?.name : "-",
              applicationDate: resume?.application_date,
              gender: resume?.gender && resume?.gender?.[0]?.text ? resume?.gender[0]?.text : "-",
              headline:resume?.headline && resume?.headline[0]?.value ? resume?.headline[0]?.value : undefined,
              isConfidential: resume?.is_confidential ? true : false,
              isFavorite: resume?.is_favourite ? true : false,
              currentState: resume?.current_state,
              is_new: resume?.is_new ? true : false,
              isFeatured: resume?.is_express ? true : false,
              imageSrc: resume?.image_url ? resume?.image_url?.[0]?.value : '',
              designation:
                resume?.current_employment && resume?.current_employment?.length > 0
                  ? resume?.current_employment[0]?.designation?.text
                  : "-",
              company:
                resume?.current_employment && resume?.current_employment?.length > 0
                  ? resume?.current_employment[0]?.employer?.text
                  : "-",
              employerDetails:
                resume?.current_employment && resume?.current_employment?.length > 0
                  ? {
                    employerDesc: resume?.current_employment[0]?.employer_description || "",
                    employerUrl: resume?.current_employment[0]?.employer_description_url || "",
                    employerHeadCount: resume?.current_employment[0]?.current_emp_count_raw || ""
                  }
                  : "N/A",
              nationality: resume?.nationality && resume?.nationality?.[0]?.text ? resume?.nationality[0]?.text : "",
              nationalitySource:resume?.nationality?.[0]?.source,
              currentCompanyExperience: resume?.current_employment?.length > 0 && resume?.current_employment?.[0]?.start_date ? currentCompanyExperience(
                resume?.current_employment[0]?.end_date,
                resume?.current_employment[0]?.start_date,
                resume?.current_employment[0]?.is_current,
                false
              ) : "-",
              title: resume?.title?.[0]?.value || "-",
              currentExperience: "string",
              totalExperience: !!resume?.final_experience 
              ? resume.final_experience?.[0]?.value === 0
                ? "Fresher"
                : resume.final_experience?.[0]?.value === null || resume?.final_experience?.[0]?.value === undefined
                ? "-"
                : getExperienceString(resume?.final_experience?.[0]?.value)
              : "-",
              resumeInfo: resume?.resume_file_path ?? [],
              salary:
                resume?.current_employment &&
                  resume?.current_employment?.length > 0 
                  // resume?.current_employment[0]?.ctc &&
                  // resume?.current_employment[0]?.final_ctc &&
                  // resume?.current_employment[0]?.currency_code
                  // resume?.current_employment[0]?.salary_confidential
                  ? getRequiredCtcDetails(
                    resume?.current_employment[0]?.ctc,
                    resume?.current_employment[0]?.final_ctc,
                    resume?.current_employment[0]?.salary_mode,
                    resume?.current_employment[0]?.currency_code,
                    resume?.current_employment[0]?.salary_confidential,
                    resume?.current_employment[0]?.predicted_max_ctc,
                    resume?.current_employment[0]?.predicted_min_ctc,
                    resume?.current_employment[0]?.predicted_salary_mode,
                    resume?.current_employment[0]?.predicted_currency_code,
                  )
                  : "-",
                predicatedSalary:resume?.current_employment && 
                                 resume?.current_employment?.[0]?.predicted_max_ctc  &&
                                 resume?.current_employment?.[0]?.predicted_min_ctc  ? true:false,
              description: resume?.title?.[0]?.value || "",
              // isSalaryConfidential:resume?.current_employment[0]?.salary_confidential,
              // currencyCode:resume?.current_employment[0]?.currency_code,
              noticePeriod: resume?.current_employment && resume?.current_employment?.[0] ?
                getNoticeText(resume?.current_employment[0]?.notice_period, 
                             resume?.current_employment[0]?.serving_notice_period,
                              resume?.current_employment[0]?.last_working_date,
                              resume?.current_employment[0]?.predicted_notice_period
                              ) : "-",
              noticePeriodValue: resume?.current_employment && resume?.current_employment?.[0] ?
                                resume?.current_employment?.[0]?.notice_period : 0,
              estimateNoticePeriod: (resume?.current_employment && resume?.current_employment.length > 0 && resume?.current_employment[0]?.predicted_notice_period) ? true : false,
              jobLocation: resume?.current_location?.length >0
                ? resume?.current_location.map((location: any) => location?.text)
                : ["-"],
              education:
                resume?.educations &&
                  resume?.educations.length > 0
                  // && resume?.educations[0]?.degree &&
                  // resume?.educations[0]?.passing_year
                  ? getEducationString(
                    resume?.educations[0]?.college,
                    resume?.educations[0]?.degree,
                    resume?.educations[0]?.passing_year,
                    resume?.educations[0]?.specialization

                  )
                  : "-",
              preferredLocation:
                resume?.preferred_locations &&
                  resume?.preferred_locations?.length > 0
                  ? resume?.preferred_locations.map((loc: any) => loc?.text)
                  : [],
              workAuth: resume?.work_auth?.[0]?.country?.text || "N/A",
              skill:
                resume?.skills && resume?.skills?.length > 0
                  ? resume?.skills?.map((skill: any) =>({
                    isGithub: skill?.is_github_skill,
                    text: skill?.text,
                    linesCount: skill?.lines_count,
                    source:skill?.source || null
                  }))
                  : ["-"],
                  modified_extracted_skills : resume?. extracted_skills?.reduce((acc:any, skills:any) => {
                    skills?.value?.forEach((skill:any) => {
                        let skillDuplicateTextIndex = acc?.findIndex((skillText:any) =>skillText?.text?.toLowerCase() === skill?.toLowerCase())
                        if (skillDuplicateTextIndex > -1) {
                            acc[skillDuplicateTextIndex].source = skills.source?.toLowerCase()
                        }
                        else {
                            acc.push({
                                text: skill,
                                source: skills.source?.toLowerCase(),
                                isExtractedSkill :true
                            })
                        }
                      
                    })
                    return acc
                },[]) || [],
                current_employment:resume.current_employment ,

              industries:
              resume.current_employment && resume.current_employment.length > 0 
              ? resume?.current_employment[0]?.employer_industry_category_list ?
              resume?.current_employment[0]?.employer_industry_category_list:''
              :[]
              ,
              pastIndustries: resume?.previous_employments?.length > 0 ? mergeEmployerIndustryCategory(resume?.previous_employments, resume?.current_employment?.[0]?.uuid
): [],
functions:
resume?.preferred_roles && resume?.preferred_roles?.length > 0
  ? returnFallbackIfEmpty(resume?.preferred_roles?.map((obj: any) => obj?.function?.text))
  : ["-"],
              roles:
              resume?.preferred_designations?.length > 0
                  ? resume.preferred_designations 
                  : ["-"],
              comment: resume?.comment && resume?.comment?.length > 0 ? resume.comment.reverse() : [],
              workExperienceInsight: resume?.work_experience_insights
                ? returnFallbackIfEmpty(
                  Object.keys(resume?.work_experience_insights)?.filter(
                    (key) => resume?.work_experience_insights[key] === true
                  )
                )
                : [],
              educationInsight: resume?.education_insight
                ? returnFallbackIfEmpty(
                  Object.keys(resume?.education_insight)?.filter((key) => resume?.education_insight[key] === true && !["is_associate", "is_bachelor", "is_master", "is_phd"]?.includes(key))
                )
                : [],
              currentWorkExperienceInsight: resume?.current_experience_insight
                ? returnFallbackIfEmpty(
                  Object.keys(resume?.current_experience_insight)?.filter(
                    (key) => resume?.current_experience_insight[key] === true
                  )
                )
                : [],
              // combined experience_insight & work_experience_insights & internal_fields
              experienceInsight: (resume?.experience_insight || resume?.work_experience_insights || resume?.internal_fields)
                ? returnFallbackIfEmpty([
                  ...(resume?.experience_insight
                    ? Object.keys(resume?.experience_insight)?.filter((key) => resume?.experience_insight[key] === true)
                    : []),
                  ...(resume?.work_experience_insights
                    ? Object.keys(resume?.work_experience_insights)?.filter((key) => resume?.work_experience_insights[key] === true)
                    : []),
                  ...(resume?.internal_fields
                    ? Object.keys(resume?.internal_fields)?.filter((key) => resume?.internal_fields[key] === true)
                    : [])
                ])
                : [],
              insightTooltips: resume?.insight_tool_tip && Object.keys(resume?.insight_tool_tip)?.length > 0 ? resume?.insight_tool_tip : "-",
              lastActive: resume?.final_active_time ? formatActivityDate(resume?.final_active_time) : "-",
              updatedOn: resume?.update_time ? resume?.update_time: "-",
              finalUpdateTime: resume?.final_update_time ? formatActivityDate(resume?.final_update_time) : "-",
              enrichedDate: resume?.enriched_date ? formatActivityDate(resume?.enriched_date) : null,
              koyoUpdateTime:resume?.enriched_date ? resume?.koyo_update_time : null,
              kiwiUserId: resume?.kiwi_profile_id,
              viewCount: resume?.viewed_count,
              downloadedCount: resume?.download_count,
              hasresume: resume?.has_resume === 0 ? false : true,
              stage: getStateNameFromMapping(resume?.current_state),
              response: resume?.response_type,
              profileUuid: resume?.p_uuid,
              isContacted: resume?.is_contacted,
              isSaved: resume?.is_saved,
              github:resume?.github_data?.url,
              mobile: {
                isVerified:
                  resume?.mobile_details?.length > 0 && resume?.mobile_details?.[0]?.verified
                    ? resume?.mobile_details[0].verified
                    : false,
                number:
                  resume?.mobile_details?.length > 0 && resume?.mobile_details?.[0]?.number
                    ? resume?.mobile_details[0].number
                    : "",
              },
              email: {
                isVerified:
                  resume?.email?.length > 0 && resume?.email?.[0]?.is_verified
                    ? resume?.email[0].is_verified
                    : false,
                id: resume?.email?.[0]?.id || "",
              },
              socialMediaUrls: resume?.social_urls?.length > 0
                ? resume?.social_urls
                : [],
              uuid: resume?.p_uuid,
              profileType: resume?.profile_type,
              siteContext: resume?.site_context,
              scoreData: resume?.score_data,
              currentCountry: resume?.current_country?.text,
              enrichment_flags: resume?.enrichment_flags,
            };
            console.log({dataItems})
            return dataItems;
          }
        );
        console.log({data})
        const response: TransformedUserProfileResponse = {
          data,
        };
        console.log({response})
        return response;
      },
    }),
    getFMHeader: builder.query<FolderManagementHeaderRes, GetFMHeaderPaylod>({
      query: (args) => (
        {
          url: callFromMiddleware(ENDPOINTS.getFMHeader),
          method: "POST",
          headers: API_HEADERS,
          body: args,
        }),
      providesTags: [FOLDER_COUNT],
    }),
    getSkills: builder.query<any, any>({
      query: ({params}) => (
        {
          url: callFromMiddleware(ENDPOINTS.getSkills),
          method: "GET",
          headers: API_HEADERS,
          params: params,
        }),
    }),

    getRevampServices: builder.query<any, void>({
  query: () => ({
    url: callFromMiddleware("/edge-folder-management/api/v2/folder/revamp/services"),
    method: "GET",
    headers: {
      domain: extractDomain(),
      ...API_HEADERS,
    },
  }),
}),

    masterDataRaven: builder.query<any, GetMasterDataRavenPayload>({
      query: (args) => ({
        url: local
          ? callFromMiddleware(ENDPOINTS.getMasterDataRaven)
          : `${extractDomain()}${ENDPOINTS.getMasterDataRaven}`,
        method: "GET",
        headers: API_HEADERS,
        params: args,
      }),
    }),
    getContactableCount: builder.query<any, GetMasterDataRavenPayload>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.getContactableCount),
        method: "POST",
        headers: API_HEADERS,
        body: {"uuid":args},
      }),
    }),
    masterDataRavenV2: builder.query<any, GetMasterDataRavenPayload>({
      query: (args) => ({
        url: local
          ? callFromMiddleware(ENDPOINTS.getMasterDataRavenV2)
          : `${extractDomain()}${ENDPOINTS.getMasterDataRavenV2}`,
        method: "GET",
        headers: API_HEADERS,
        params: args,
      }),
    }),
    contactInitiation: builder.query<any, any>({
      query: (body) => ({
        url: callFromMiddleware(ENDPOINTS.initiateContactability),
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    contactDetails: builder.query<any, any>({
      query: (args) => ({
        url:  `${callFromMiddleware(ENDPOINTS.getContactDetails)}/${args}`,
        method: "GET",
        headers: API_HEADERS,
        // params: args,
      }),
    }),
    redirectToCampaign: builder.mutation({
      query: (payload: any) => ({
        url: callFromMiddleware(ENDPOINTS.redirectToCampaign),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
    }),
    redirectToWhatsapp: builder.mutation({
      query: (payload: any) => ({
        url: callFromMiddleware(ENDPOINTS.redirectToWhatsapp),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
    }),
    
    fetchFolders: builder.mutation<FolderOptionType[],
    void
    >({
      query: (fName) => ({
        url: callFromMiddleware(ENDPOINTS.fetchFolders)+"/"+fName,
        method: 'GET',
        headers: API_HEADERS,
      })
    }),
    createFolder: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.createFolder),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [FETCH_FOLDER]),
    }),

    fetchTemplates: builder.query<TemplateType[],
      void
    >({
      query: () => ({
        url: callFromMiddleware(ENDPOINTS.fetchSMSTemplates),
        method: 'GET',
        headers: API_HEADERS,
      }),
    }),
    sendSMS: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.sendSMS),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      })
    }),
    cloneProfile: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.cloneProfile),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [USER_PROFILES, FOLDER_COUNT, FETCH_FOLDER]),
    }),
    removeProfile: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.removeProfile),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [USER_PROFILES, FOLDER_COUNT]),
    }),
    restoreProfile: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.restoreProfile),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [USER_PROFILES, FOLDER_COUNT]),
    }),
    favouriteProfile: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.favouriteProfile),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [USER_PROFILES, FOLDER_COUNT]),
    }),
    moveToState: builder.mutation({
      query: (payload) => ({
        url: callFromMiddleware(ENDPOINTS.moveToState),
        method: 'POST',
        headers: API_HEADERS,
        body: payload
      }),
      invalidatesTags: (result: any, error: any) => (error ? [] : [USER_PROFILES, FOLDER_COUNT]),
    }),
    getSavedData: builder.query<any, GetSavedDataPayload>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.getSavedData),
        method: "POST",
        headers: API_HEADERS,
        body: args,
      }),
    }),
    getConnections: builder.query<any, GetConnectionsPayload>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.getConnections),
        method: "POST",
        headers: API_HEADERS,
        body: args,
      }),
    }),
    checkEmail: builder.query<any, any>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.checkEmail),
        method: "GET",
        headers: API_HEADERS,
      }),
    }),
    getFmProfileContacted: builder.query<ProfilesContactedRes[], ProfilesContactedPayload>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.fetchFmProfileContactedDetails),
        method: "POST",
        headers: API_HEADERS,
        body: args,
      }),
    }),
    getLinkedSearchData: builder.query<LinkedSearchRes[], void>({
      query: (args) => ({
        url: callFromMiddleware(ENDPOINTS.getLinkedSearch),
        method: "GET",
        headers: API_HEADERS,
        params: args,
      }),
    }),
    getLinkedSearchRedirectionUrl: builder.query<any, void>({
      query: (args) => ({
        url: extractDomain() + ENDPOINTS.getLinkedSearchUrl,
        method: "GET",
        headers: API_HEADERS,
        params: args,
      }),
    }),
    getShortlistedByRec: builder.query<
      ManageFolderAPIRecShareRes,
      GetShareFolderRecDetailsPaylod
    >({
      query: (args: any) => ({
        url: `${callFromMiddleware(ENDPOINTS.getFMRecDetails)}`,
        method: "POST",
        headers: API_HEADERS,
        params: { folderId: args.folderId, searchName: args.searchName },
        body: {},
      }),
    }),
    masterData: builder.query<MasterDataResponse, GetMasterDataPayload>({
      query: (args) => ({
          url: local ? callFromMiddleware(ENDPOINTS.getMasterData) : `${extractDomain()}${ENDPOINTS.getMasterData}`,
          method: "GET",
          headers: API_HEADERS,
          params: args,
        }),
    }),
    downloadExcelNew: builder.query<any, any>({
      query: (args) => ({
          url: callFromMiddleware(ENDPOINTS.downloadExcelNew),
          method: "POST",
          headers: API_HEADERS,
          body:args
        }),
    }),
    

    trackHealth : builder.query<any, void>({
      query: (body) => ({
        url: callFromMiddleware(ENDPOINTS.healthTracker),
        method: "POST",
        headers: API_HEADERS,
        body: body,
      }),
    }),
    getStageTrail: builder.query<TrailResponse, TrailPayload>({
      query: (args) => ({
          url:  callFromMiddleware(ENDPOINTS.getStageTrail),
          method: "GET",
          headers: API_HEADERS,
          params: args,
        }),
    }),

  })
});

export const {
  useGetRevampServicesQuery,
  useGetSkillsQuery,
  useGetFMHeaderQuery,
  useGetUserProfileQuery,
  useGetRawUserProfileQuery,
  useLazyMasterDataRavenQuery,
  useLazyMasterDataRavenV2Query,
  useLazyGetUserProfileQuery,
  useLazyContactInitiationQuery,
  useLazyContactDetailsQuery,
  useLazySavedDataQuery,
  useLazyGetFmProfileContactedQuery,
  useRedirectToCampaignMutation,
  useRedirectToWhatsappMutation,
  useFetchFoldersMutation,
  useCreateFolderMutation,
  useFetchTemplatesQuery,
  useSendSMSMutation,
  useCloneProfileMutation,
  useRemoveProfileMutation,
  useRestoreProfileMutation,
  useFavouriteProfileMutation,
  useMoveToStateMutation,
  useLazyGetSavedDataQuery,
  useGetLinkedSearchDataQuery,
  useLazyGetConnectionsQuery,
  useLazyGetLinkedSearchRedirectionUrlQuery,
  useLazyGetShortlistedByRecQuery,
  useLazyTrackHealthQuery,
  useMasterDataQuery,
  useLazyCheckEmailQuery,
  useLazyDownloadExcelNewQuery,
  useLazyGetContactableCountQuery,
  useLazyGetStageTrailQuery,
} = folderManagementApi;

export default folderManagementApi;
